'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from 'angular';
import SupportsController from './controller/support';
import SupportModalCreateController from './controller/supportModalCreate';
import SupportModalSelectController from './controller/supportModalSelect';
//import SupportFilterController from './controller/supportFilter';
import SupportTableDirective from './directive/supportTable';
import SupportSelectDirective from './directive/supportSelect';
import SupportFilterDirective from './directive/supportFilter';
import SupportTableRowDirective from './directive/supportTableRow';
import SupportService from './service/support';
import SupportFilterService from './service/filter';

export default angular.module('investmentProject.support', [])
                      .controller('SupportsController', SupportsController)
                      .controller('SupportModalCreateController', SupportModalCreateController)
                      .controller('SupportModalSelectController', SupportModalSelectController)
                      //.controller('SupportFilterController', SupportFilterController)
                      .directive('supportTable', SupportTableDirective)
                      .directive('supportSelect', SupportSelectDirective)
                      .directive('supportTableRow', SupportTableRowDirective)
                      .directive('supportFilter', SupportFilterDirective)
                      .factory('SupportService', SupportService)
                      .factory('SupportFilterService', SupportFilterService)
    .name;
